import { apiClient } from '../../config/axios-client'
import type { UploadPolicy, UploadPolicySettings, UploadWorkflow } from '../../shared/models/UploadPolicy'


// const megabyte = 1024 * 1024

// const policies: Record<UploadWorkflow, UploadPolicy> = {
//   'workspace-media': {
//     maxFileSizeBytes: 100 * megabyte,
//     formats: [
//       { extension: 'jpg', mimeType: 'image/jpeg' },
//       { extension: 'png', mimeType: 'image/png' },
//       { extension: 'mp4', mimeType: 'video/mp4' },
//       { extension: 'mpeg', mimeType: 'video/mpeg' },
//       { extension: 'mp3', mimeType: 'audio/mpeg' },
//       { extension: 'wav', mimeType: 'audio/wav' },
//     ],
    
//   },
//   'reference-image': {
//     maxFileSizeBytes: 10 * megabyte,
//     formats: [
//       { extension: 'jpg', mimeType: 'image/jpeg' },
//       { extension: 'png', mimeType: 'image/png' },
//     ],
//   },
// }

export const uploadPolicyApi = {

  get: () => apiClient.get<UploadPolicySettings>(`workspaces/upload-file-settings`)
  
}